import { useState, Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import RoomPopup from '../popups/RoomPopup'
import './group-trip-packages.sass'
import InputNumber from '../forms/InputNumber'
import PriceConverter from '../helpers/PriceConverter'
import GroupBookingPopup from '../popups/GroupBookingPopup'
import API from '../../api'

const NumberOfSpots = ({ spots }) => {
  return (<span className='number-of-spots'>
    <FormattedMessage id='spots_left' values={{
      qty: spots,
    }} defaultMessage='Only { qty, plural, one {# spot } other {# spots } } left' />
  </span>)
}

export default function GroupTripPackages({ mainPage, items, slug, currency, tripInfo, onChange, groupTripId }) {
  const areaFormat = 10
  const [roomPopupIsOpen, togglePopup] = useState(false)
  const [roomInfo, setRoomInfo] = useState({ })
  const [isOpen, triggerGroupPopup] = useState(false)
  const [packages, setPackages] = useState(items)

  function openPopup(room) {
    togglePopup(true)
    setRoomInfo(room)
  }

  function changePackageQuantity(qty, pack) {
    let selectedPackages = []
    pack.quantity = qty

    packages.forEach(item => {
      if(item.quantity) {
        selectedPackages.push({
          roomCategory: item.roomCategory ? item.roomCategory.id : '',
          price: item.price,
          quantity: item.quantity,
          groupTripPackage: item.id,
        })
      }
    })

    if(typeof onChange === 'function') {
      onChange(selectedPackages)
    }
  }

  if(!packages) {
    API(`marketplace/${slug}/packages`).get().then(function(packs) {
      setPackages(packs)
    })
  }

  return <div className='group-package'>
    { mainPage && (<GroupBookingPopup currency={currency} groupTripId={groupTripId} closeModal={() => triggerGroupPopup(false)} isOpen={isOpen} packages={packages} tripInfo={tripInfo} />) }
    <RoomPopup isOpen={roomPopupIsOpen} roomInfo={roomInfo} closeModal={() => togglePopup(false)} areaFormat={areaFormat} />
    { packages && packages.map(pack => {
      return (
        <div className='group-package-row' key={pack.id}>
          <div className='group-package__info'>
            <p className='group-package__title'>{ pack.title }</p>
            { pack.description && (<p className='group-package__description'>
              <i className='font-icons info-icon' />
              { pack.description }
            </p>) }
            { pack.roomCategory &&
            (<p className='group-package__room' onClick={() => openPopup(pack.roomCategory)}>
              <i className='font-icons room-icon' />
              {pack.roomCategory.title}
            </p>) }
          </div>
          {
            pack.itemsLeft === 0 ? (
              <div className='sold-out'>
                <i className='font-icons fail-icon-new' />&nbsp;<FormattedMessage id='sold_out' defaultMessage='Sold out' />
              </div>
            ) : (
              <Fragment>
                <div className='group-package__price'>
                  <strong>
                    <PriceConverter amount={pack.price} currency={currency} />
                  </strong>
                  <br />
                  <FormattedMessage id='per_person' defaultMessage='per person' />
                </div>
                { mainPage ? (
                  <div className='button-container'>
                    <button className='btn-red' onClick={() => triggerGroupPopup(true)}>
                      <FormattedMessage id='request_to_book' defaultMessage='Request to book' />
                    </button>
                    { pack.itemsLeft !== null && pack.itemsLeft <= 4 ? <NumberOfSpots spots={pack.itemsLeft} /> : ''}
                  </div>
                ) : (
                  <div className='plus-minus-btn-container'>
                    <div className='input-counter'>
                      <InputNumber disabled plusMinusSeparate minNumber={0} value={pack.quantity || 0} onChange={(val) => changePackageQuantity(val, pack)} />
                    </div>
                    { pack.itemsLeft !== null && pack.itemsLeft <= 4 ? <NumberOfSpots spots={pack.itemsLeft} /> : ''}
                  </div>
                ) }
              </Fragment>
            )
          }
        </div>
      )
    })
    }
  </div>
}
